import React from 'react';
import ImageLogo from '../../assets/images/fetal-id-education.png';
import LogoStyles from './styles';
import { withRouter } from 'react-router-dom';

const Logo = ({ history }) => {
	return (
		<LogoStyles
			className="logo"
			src={ImageLogo}
			alt="Logo medicina fetal"
			onClick={() => history.push('/')}
		/>
	);
};

export default withRouter(Logo);
